import { ServiceResponse } from '@sdbn/appclient';
import { TransportWeighing } from './../model/transport-weighing';
import { HttpService } from '@sdbn/appclient';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Identity } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WeighTransportService {

  constructor(private httpService: HttpService) { }

  public getTransportWeighings(transportIdentity: Identity): Observable<TransportWeighing[]> {
    return this.httpService.postWithContext(environment.weighingEndpoint + '/weighings', transportIdentity);
  }

  public createWeighing(weighing: TransportWeighing): Observable<ServiceResponse> {
    return this.httpService.postWithContext(environment.weighingEndpoint + '/create', weighing);
  }

  public createPrintout(transportIdentity: Identity) {

    // Trigger opening a new tab. Must be as close as possible to a user action event.
    const newWindow = window.open('', 'weighing-printout');

    // keep focus in current window
    window.focus();

    const url = `${environment.weighingEndpoint}/printout`;
    this.httpService.postWithArraybufferResponse<any>(url, transportIdentity).subscribe(result => {

      const file = new Blob([result], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // we can open the file in a new tab
      if (newWindow !== null) {
        newWindow.location.href = fileURL;
      } else { // Fallback, if initial opener does not work. But popup blockers will block this.
        window.open(fileURL);
      }

    }, error => {
      console.error(error);
    });
  }
}
